const PROD_ENVIRONMENTS = ['integration', 'production', 'production-eu', 'P2'];

/**
 * Determine whether the passed environment is considered production
 * @param env Environment name
 * @returns true/false
 */
export default function isProduction(env: string | undefined): boolean {
  return PROD_ENVIRONMENTS.includes(env ?? '');
}
